module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Introduction: Living Wisely with the Church Fathers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("1 “They Looked like Flaming Angels”: Martyrdom")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 “A Solid Drop of Gold”: Wealth and Poverty")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 “The Misery of These Evils”: War and Military Service")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 “The Closest of Relationships”: Sex and the Dynamics of Desire")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 “One Hope, One Desire, One Way of Life”: Life as Male and Female, and the Goodness and Beauty of Marriage")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 “From the Cradle to the Grave”: Life and Death")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p7chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 “Let the Races Begin!”: Entertainment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p8chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Learning to Live a Good Life with God:"), _c('br'), _vm._v("The Well-Ordered Heart")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Name and Subject Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Living Wisely with the Church Fathers")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0